export default function sorter(columns, rows, query, callback) {
    const value = columns.find((c) => c.id === query).value;
    let sorted = [...rows].sort((a, b) => value(a) > value(b) ? 1 : value(a) < value(b) ? -1 : 0);
    if (rows[0].id === sorted[0].id) sorted.reverse();
    callback(sorted);
}